export interface InstallmentResult {
  totalWithInterest: number;
  interestLabel: string;
}

export function calculateTotalWithInterest(
  baseAmount: number,
  installments: number
): InstallmentResult {
  const interestRates: { [installments: number]: number } = {
    5: 0.085,
    6: 0.085,
    7: 0.095,
    8: 0.105,
    9: 0.115,
    10: 0.125,
    11: 0.125,
    12: 0.145,
  };

  const rate = interestRates[installments] ?? 0;
  const totalWithInterest = +(baseAmount * (1 + rate)).toFixed(2);
  const interestLabel = rate > 0 ? 'com juros' : 'sem juros';

  return { totalWithInterest, interestLabel };
}
